module.exports = {"130406001":"滏阳东路街道","130406100":"临水镇","130406101":"峰峰镇","130406102":"新坡镇","130406103":"大社镇","130406104":"和村镇","130406105":"义井镇","130406106":"彭城镇","130406107":"界城镇","130406108":"大峪镇","130406200":"西固义乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130406.json
// module id = 102
// module chunks = 0